var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingUnsorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.397 4.02052L10.0487 2.67223C9.81904 2.44259 9.44672 2.44259 9.21708 2.67223L7.86878 4.02052M9.63288 2.84446L9.63288 9.90084",
    stroke: "#BBBDC0",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10474 9.31281L4.75644 10.6611C4.5268 10.8907 4.15448 10.8907 3.92484 10.6611L2.57655 9.31281M4.34064 10.4889L4.34064 3.4325",
    stroke: "#BBBDC0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingUnsorted);
export default __webpack_public_path__ + "static/media/sorting-unsorted.1cc9387744e514f262d0769d64b34400.svg";
export { ForwardRef as ReactComponent };